import { GET_CAPA_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getCAPADataAPI = async (): Promise<any> => {
    const response = await axios.get(GET_CAPA_DATA_API);
    return response.data;
};

export const getCAPADataByYearAPI = async (year: string): Promise<any> => {
    const response = await axios.get(`${GET_CAPA_DATA_API}/${year}`);
    return response.data;
};
